import React, { useEffect, useState } from 'react'
import DropdownComp from '../common/form-components/dropdown/DropdownComp'
import RolesService from '../../services/roles/roles.service'

const RolesDropDown = ({ value, onChange }) => {
  const [roles, setRoles] = useState([])

  useEffect(() => {
    getRoles()
  }, [])

  const getRoles = async () => {
    const resp = await RolesService.getAll({})
    if (resp) {
      setRoles(resp)
    }
  }

  return (
    <DropdownComp
      value={value?._id || value}
      options={roles?.resp}
      name="role"
      optionLabel="role"
      optionValue="_id"
      onChange={onChange}
    />
  )
}
export default RolesDropDown
